<template xmlns:div="http://www.w3.org/1999/html">
  <div>
<!--    <div v-if="application === null">
      not found
    </div>-->
    <el-container class="modal-container application-detail-form" v-if="application !== null">

      <el-header>
        <el-row>
          <el-col>
            #{{ editApplication.id }}
            <el-divider direction="vertical"></el-divider>
            {{ `${editApplication.full_name}` }}
            <copy-application-link-btn :application-id="application.id"/>
<!--            <repeat-application-tag-link v-if="application.origin_applications" :application="application"/>-->
            <el-divider></el-divider>
          </el-col>
        </el-row>
      </el-header>

      <el-main>

        <el-form :label-position="labelPosition">
          <el-collapse class="application-similars-wrapper" v-if="application.similar_applications.length">
            <el-collapse-item title="Похожие заявлления" name="1">
              <template slot="title">
                Похожие заявления
                <tooltip content="Имеются такие заявления с такими же номером телефона, ИИН и E-mail" />
              </template>
              <ul>
                <li v-for="(similar_application, i) in application.similar_applications" :key="i">
                  <router-link
                    :to="{name: 'application',params: {id: similar_application.id}}"
                    target="_blank">
                    #{{similar_application.id}}| {{similar_application.repr}}
                  </router-link>
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>

          <!--Start application statuses-->
          <div class="statuses-container">
            <div class="status-wrapper">
              <div class="status-title">Статус заявления</div>
              <div class="status-switcher">
                <application-status-switcher v-model="application.status" :application-id="application.id"/>
              </div>
            </div>
            <div class="status-wrapper">
              <div class="status-title">Статус вселения</div>
              <div class="status-switcher">
                <settlement-status-switcher v-model="application.settlement_status" :application-id="application.id"/>
              </div>
            </div>
          </div>
          <!--End application statuses-->

          <!--Start application dates-->
          <el-descriptions direction="vertical" :column="3" size="medium" >
            <el-descriptions-item label="Дата подачи заявления">
              <list-item-field v-model="applyDate" :edit="false"/>
            </el-descriptions-item>
            <el-descriptions-item label="Дата вселения">
              <list-item-field v-model="checkinDate" :edit="isEdit">
                <template v-slot:value>
                  {{checkinDate}}
                </template>
                <template v-slot:edit>
                  <el-date-picker type="date" v-model="editApplication.checkin_date" size="mini" placement="bottom-start"/>
                </template>
              </list-item-field>
            </el-descriptions-item>
            <el-descriptions-item label="Дата выселения">
              <list-item-field v-model="checkoutDate" :edit="isEdit">
                <template v-slot:value>
                  {{checkoutDate}}
                </template>
                <template v-slot:edit>
                  <el-date-picker type="date" v-model="editApplication.checkout_date" size="mini" placement="bottom-start"/>
                </template>
              </list-item-field>
            </el-descriptions-item>
          </el-descriptions>
          <!--End application dates-->

          <list-item-field label="Язык заявления" v-model="application.lang" :edit="isEdit">
            <template v-slot:value>
              {{applicationLanguage}}
            </template>
            <template v-slot:edit>
              <el-select v-model="editApplication.lang" size="mini">
                <el-option value="ru" label="Русский"></el-option>
                <el-option value="kz" label="Казахский"></el-option>
                <el-option value="en" label="Английский"></el-option>
              </el-select>
            </template>
          </list-item-field>

          <list-item-field label="Причина изменения статуса"
                           v-model="editApplication.status_change_reason"
                           :edit="isEdit"
                           type="textarea"/>

          <!--Start application private info-->
          <el-descriptions class="custom-bordered" title="Личные данные" direction="vertical" :column="6" size="medium" border>
            <el-descriptions-item label="Фамилия">
              <list-item-field v-model="editApplication.last_name" :edit="isEdit" />
            </el-descriptions-item>
            <el-descriptions-item label="Имя">
              <list-item-field v-model="editApplication.first_name" :edit="isEdit" />
            </el-descriptions-item>
            <el-descriptions-item label="Отчество" :span="2">
              <list-item-field v-model="editApplication.middle_name" :edit="isEdit" />
            </el-descriptions-item>
            <el-descriptions-item label="Пол">
              <list-item-field label="" :value="$tc(`form.gender.${application.gender}`)" :edit="isEdit">
                <template v-slot:edit>
                  <el-select
                      name="gender"
                      id="gender"
                      v-model="editApplication.gender"
                  >
                    <el-option value="male" label="Мужской"></el-option>
                    <el-option value="female" label="Женский"></el-option>
                  </el-select>
                </template>
              </list-item-field>
            </el-descriptions-item>
            <el-descriptions-item label="ИИН">
              <list-item-field label="" v-model="editApplication.iin" :edit="isEdit" />
            </el-descriptions-item>
          </el-descriptions>
          <!--End application private info-->

          <!--Start application settlement info-->
          <el-descriptions class="custom-bordered" title="Информация о вселении" direction="vertical" :column="1" size="medium" border>
            <el-descriptions-item label="Приказ вселения">
              <list-item-field v-model="editApplication.checkin_order" :edit="isEdit"/>
            </el-descriptions-item>
            <el-descriptions-item label="Комната">
              <list-item-field v-model="editApplication.room" :edit="isEdit"/>
            </el-descriptions-item>
          </el-descriptions>
          <!--End application settlement info-->

          <!--Start application contact info-->
          <el-descriptions class="custom-bordered" title="Контактная информация" direction="vertical" :column="2" size="medium" border>
            <el-descriptions-item label="Контактный телефон">
              <list-item-field v-model="editApplication.phone" :edit="isEdit" />
            </el-descriptions-item>
            <el-descriptions-item label="Email">
              <list-item-field v-model="editApplication.email" :edit="isEdit" type="email"/>
            </el-descriptions-item>
          </el-descriptions>
          <!--End application contact info-->

          <list-item-field label="Адрес прописки" :value="editApplication.country" :edit="isEdit">
            <template v-slot:edit>
              <ul class="address-list">
                <li>Страна: <country-select v-model="editApplication.country"/></li>
                <li>Регион: <region-select v-model="editApplication.region"/></li>
                <li>Город: <el-input v-model="editApplication.city" size="mini"></el-input></li>
                <li>Улица: <el-input v-model="editApplication.street" size="mini"></el-input></li>
                <li>Дом: <el-input v-model="editApplication.house" size="mini"></el-input></li>
                <li>Квартира: <el-input v-model="editApplication.flat" size="mini"></el-input></li>
              </ul>
            </template>
            <template v-slot:value>
              <ul>
                <li>Страна: {{ getCountry(application.country) }}</li>
                <li>Регион: {{ getRegion(application.region) }}</li>
                <li>Город: {{ application.city }}</li>
                <li>Улица: {{ application.street }}</li>
                <li>Дом: {{ application.house }}</li>
                <li>Квартира: {{ application.flat }}</li>
              </ul>
            </template>
          </list-item-field>

          <!--Start application education info-->
          <el-descriptions class="custom-bordered" title="Информация об обучении" direction="horizontal" :column="1" size="medium" border>
            <el-descriptions-item label="Место обучения">
              <list-item-field :value="application.study_place.name_ru" :edit="isEdit">
                <template v-slot:edit>
                  <el-select
                      name="study_place"
                      id="study_place"
                      v-model="editApplication.study_place.id"
                  >
                    <el-option
                        :value="item.id"
                        v-for="item in study_places"
                        :key="item.id"
                        :label="item.name_ru"
                    />
                  </el-select>
                </template>
              </list-item-field>
            </el-descriptions-item>
            <el-descriptions-item label="Форма оплаты">
              <list-item-field :value="application.payment_method.name_ru" :edit="isEdit">
                <template v-slot:edit>
                  <el-select
                      name="payment_method"
                      id="payment_method"
                      v-model="editApplication.payment_method.id"
                  >
                    <el-option
                        :value="item.id"
                        v-for="item in payment_methods"
                        :key="item.id"
                        :label="item.name_ru"
                    />
                  </el-select>
                </template>
              </list-item-field>
            </el-descriptions-item>
            <el-descriptions-item label="Курс">
              <list-item-field v-model="editApplication.course" :edit="isEdit" />
            </el-descriptions-item>
            <el-descriptions-item label="Уровень обучения">
              <list-item-field v-model="editApplication.edu_level" :edit="false">
                <template v-slot:value>
                  {{edu_level[$root.$i18n.locale][editApplication.edu_level]}}
                  <tooltip content="Меняется автоматически при изменении места обучения" />
                </template>
              </list-item-field>
            </el-descriptions-item>
          </el-descriptions>
          <!--End application education info-->

          <list-item-field
              label="Социальное положение"
              :value="application.social_status ? application.social_status.name_ru : 'Не указано'"
              :edit="isEdit"
          >
            <template v-slot:edit>
              <application-form-social-status
                  :social-statuses="social_statuses"
                  v-model="editApplication.social_status"
              />
            </template>
          </list-item-field>
          <list-item-field label="Подтверждение социального положения" :value="false" :edit="isEdit">
            <template v-slot:edit>
              <upload-file v-model="social_status_doc"/>
            </template>
            <template v-slot:value>
              <a
                v-if="application.social_status_doc"
                :href="application.social_status_doc"
                @click.prevent="downloadDoc"
                target="_blank"
              >
                Скачать документ
              </a>
              <div v-else>
                Документ о подтверждении социального положения не прикреплен.
              </div>
            </template>
          </list-item-field>
          <list-item-field label="Паспорт вакцинации" :value="false" :edit="isEdit">
            <template v-slot:edit>
              <upload-file v-model="vac_doc"/>
            </template>
            <template v-slot:value>
              <a
                v-if="application.vac_doc"
                :href="application.vac_doc"
                @click.prevent="downloadDoc"
                target="_blank"
              >
                Скачать документ
              </a>
              <div v-else>
                Документ паспорта вакцинации не прикреплен.
              </div>
            </template>
          </list-item-field>

        </el-form>

      </el-main>

      <el-footer>
        <button class="btn btn-secondary " @click="toggleEdit" v-if="!isEdit">Редактировать</button>
        <button class="btn btn-secondary" @click="updateApplication" v-if="isEdit">Сохранить</button>
        <button class="btn btn-secondary" @click="toggleEdit" v-if="isEdit">Отмена</button>
        <button class="btn btn-secondary" @click="printApplicationDialogVisible = true">Получить справку</button>
        <button class="btn btn-primary" @click="closeDetail" v-if="!isApplicationPage">Закрыть</button>
      </el-footer>

      <el-dialog
        :visible.sync="printApplicationDialogVisible"
        :before-close="closePrintApplicationDialog"
        :close-on-click-modal="false"
        title="Распечатать справку"
        modal-class="application-print-dialog"
        append-to-body>
        <div class="application-print-wrapper">
          <application-print-template :application="application" @closeDetail="printApplicationDialogVisible = false"/>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>
<script>
import '@/assets/css/modal.css'
import host from '@/../config/host'
import axios from 'axios'
import {mapState} from 'vuex'
import adminApi from '@/api/admin'
import formApi from '@/api/form'
import edu_level from '@/lang/edu_level'
import {date_default_format, get_country_name, get_region_name} from '@/helpers/formatters'
import applicationApi from '@/api/application'
import ApplicationFormSocialStatus from '@/components/ApplicationFormSocialStatus'
import UploadFile from '@/components/form/UploadFile'
import ListItemField from '@/components/ListItemField'
import {actionTypes as adminActions} from '@/store/modules/admin'
import {actionTypes as modalActions} from '@/store/modules/modal'
import CountrySelect from '@/components/form/CountrySelect'
import RegionSelect from '@/components/form/RegionSelect'
import SettlementStatusSwitcher from '@/components/Admin/SettlementStatusSwitcher'
import ApplicationStatusSwitcher from '@/components/Admin/ApplicationStatusSwitcher'
import Tooltip from '@/components/utils/Tooltip'
import CopyApplicationLinkBtn from '@/components/Admin/CopyApplicationLinkBtn'
import ApplicationPrintTemplate from '@/components/Admin/Application/ApplicationPrintTemplate'

export default {
  components: {
    ApplicationFormSocialStatus, ListItemField, UploadFile, CountrySelect, RegionSelect, SettlementStatusSwitcher,
    ApplicationStatusSwitcher, Tooltip, CopyApplicationLinkBtn, ApplicationPrintTemplate
  },
  data() {
    return {
      printApplicationDialogVisible: false,

      host: host,
      isEdit: false,
      labelPosition: 'top',
      dialogVisible: false,
      editApplication: {},
      study_places: [],
      payment_methods: [],
      social_statuses: [],
      social_status_doc: null,
      vac_doc: null,
      edu_level: edu_level
    }
  },
  computed: {
    ...mapState({
      application: function (state) {
        this.editApplication = {...state.modal.applicationDetail}

        if(state.modal.applicationDetail)
          this.dialogVisible = true
        else
          this.dialogVisible = false

        return state.modal.applicationDetail
      },
    }),
    applyDate: function () {
      return date_default_format(this.application.date_insert)
    },
    checkinDate: function () {
      return this.application.checkin_date ? date_default_format(this.application.checkin_date) : '-'
    },
    checkoutDate: function () {
      return this.application.checkout_date ? date_default_format(this.application.checkout_date) : '-'
    },
    applicationLanguage(){
      if(this.application.lang === 'kz') return 'Казахский'
      if(this.application.lang === 'en') return 'Английский'
      return 'Русский'
    },
    //check if current page is router page with name 'application'
    isApplicationPage(){
      return this.$route.name === 'application'
    }
  },
  mounted() {
    formApi.getFormData().then((response) => {
      let data = response.data
      this.study_places = data.study_places
      this.payment_methods = data.payment_methods
      this.social_statuses = data.social_statuses
    })
  },
  methods: {
    getCountry(countryCode){
      return get_country_name(countryCode, this.$root.$i18n.locale)
    },
    getRegion(regionCode){
      return get_region_name(regionCode, this.$root.$i18n.locale)
    },
    closeDetail: function () {
      this.isEdit = false
      this.dialogVisible = false
      this.$store.dispatch(modalActions.resetApplicationDetail)
    },
    closePrintApplicationDialog: function () {
      this.printApplicationDialogVisible = false
    },
    toggleEdit: function () {
      this.isEdit = !this.isEdit
      this.editApplication = this.application
      this.vac_doc = null
      this.social_status_doc = null
    },
    async updateApplication() {
      if(this.social_status_doc) await this.uploadFile('social_status_doc', this.social_status_doc)
      if(this.vac_doc) await this.uploadFile('vac_doc', this.vac_doc)

      await this.$store
          .dispatch(adminActions.updateApplication, {
            application: this.editApplication,
          })
          .then((response) => {
            this.$store.dispatch(modalActions.setApplicationDetail, {
              application: this.editApplication,
            })

            this.isEdit = false
          })
          .then(() => {
            this.$message({message: 'Изменения сохранены', type: 'success'})
            //??
            this.$parent.getList()
          })
          .catch(() => (this.isEdit = false))
    },
    downloadDoc(e) {
      let link = e.currentTarget.href
      const FileDownload = require('js-file-download')
      axios
          .get(link, {
            responseType: 'blob',
          })
          .then((response) => {
            let filename = link.substring(link.lastIndexOf('/') + 1)
            FileDownload(response.data, filename)
          })
    },
    uploadFile(type, file){
      let sendData = new FormData()
      sendData.append('doc_type', type)
      sendData.append('file', file)
      return applicationApi.uploadFile(this.application.id, sendData)
    },
  },
  watch: {
    editApplication: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.social_status !== oldVal.social_status) {
          this.editApplication.social_status = newVal.social_status
        }
      }
    }
  }
}
</script>